var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
var GroupTransferActionDropdown = function (_a) {
    var record = _a.record, handleRemove = _a.handleRemove;
    return (_jsx(Fragment, { children: _jsx("div", __assign({ className: 'd-flex gap-2 mt-3' }, { children: _jsx("button", __assign({ type: 'button', onClick: function () { return handleRemove(record.talent.pubId); }, className: 'btn btn-danger btn-active-light-primary btn-sm mr-2' }, { children: "Remove" })) })) }));
};
export default GroupTransferActionDropdown;
